import React from 'react'
import { ListNotices } from '@core/Areas/VenueMode/Components/Notices/Notices.styles'
import { LOCATION_DISABLED_TEXT, LOCATION_DISABLED_TITLE } from '@core/Areas/VenueMode/constants'

interface ImpreciseNoticeIOSProps {
  isSafari: boolean
  isChrome: boolean
  browserName: string
}

export const ImpreciseNoticeIOS = ({
  isSafari,
  isChrome,
  browserName,
}: ImpreciseNoticeIOSProps): React.JSX.Element => {
  return (
    <>
      <b>{LOCATION_DISABLED_TITLE}</b>
      <br />
      <i>{LOCATION_DISABLED_TEXT}</i>
      <br />
      <b>1. Enable location services for your device and {browserName}</b>
      <ListNotices>
        <li>
          Open phone <b>Settings → Privacy & Security → Location Services</b>.
        </li>
        <li>
          Make sure <b>Location Services</b> is toggled <b>ON</b>.
        </li>
        <li>
          Scroll down to <b>{browserName} </b>
          and choose <b>"While Using the App"</b>
        </li>
        <li>
          Ensure <b>Precise Location</b> is enabled
        </li>
      </ListNotices>
      <br />
      {isSafari && (
        <>
          <b>2. Re‑enable Location Access for TABtouch after it was denied</b>
          <br />
          If you have denied location access for TABtouch previously, Safari will not automatically
          prompt again and you'll need to change the permission via Safari's "Website Settings":
          <ListNotices>
            <li>In the Safari Browser, tap the icon next to the address bar.</li>
            <li>
              Under <b>Website Settings → Location</b>
            </li>
            <li>
              Choose <b>Allow</b>
            </li>
          </ListNotices>
        </>
      )}
      {isChrome && (
        <>
          <b>2. Re-install the Chrome app and allow TABtouch to access your location</b>
          <br />
          If you have denied location access for TABtouch previously, you'll need to re-install the
          Chrome app to allow access again.
          <br />
          When prompted: <b>"Allow this site to access your location?"</b> - select <b>Allow</b>.
          <br />
        </>
      )}
      <br />
      <b>3. Refresh the page</b>
    </>
  )
}
